import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CountFavoritesService {

  private favoritesNumber: number = 0;
  private static MAX_FAVORITES_NUMBER = 25;

  get getFavoritesNumber(): number {
    return this.favoritesNumber;
  }

  get limitHasBeenReached(): boolean {
    return this.favoritesNumber >= CountFavoritesService.MAX_FAVORITES_NUMBER;
  }

  setFavoritesNumber(favoritesNumber: number): void {
    this.favoritesNumber = favoritesNumber;
  }

  incrementFavoritesNumber(favoritesNumber: number): void {
    this.favoritesNumber = this.favoritesNumber + favoritesNumber;
  }

  decrementFavoritesNumber(favoritesNumber: number): void {
    this.favoritesNumber = this.favoritesNumber - favoritesNumber;
  }

}
